var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaveClassIcon = function SvgLeaveClassIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M9.497 10.315a.35.35 0 0 0 .083-.3.37.37 0 0 0-.165-.255 5.6 5.6 0 0 0-2.998-.884 5.66 5.66 0 0 0-5.41 4.017.37.37 0 0 0 .06.33.36.36 0 0 0 .3.15h6.489a.37.37 0 0 0 .367-.308 6.04 6.04 0 0 1 1.274-2.75M2.693 4.567a3.56 3.56 0 1 0 7.119 0 3.56 3.56 0 0 0-7.12 0zM14.12 9.25a4.87 4.87 0 1 0 4.872 4.872A4.88 4.88 0 0 0 14.12 9.25m2.624 5.621h-5.246a.75.75 0 0 1 0-1.499h5.246a.75.75 0 0 1 0 1.499"
  })));
};
export { SvgLeaveClassIcon as ReactComponent };